import styles from './styles.module.scss';
import React, { useContext } from 'react';
import { AdminContext } from '../../context/AdminContext';

const TooltipBottom = ({
  text,
  children,
  cursor = false,
  extraClassName = 'top-[150%]',
  className = '',
  onClick,
}) => {
  const { themeColor } = useContext(AdminContext);

  return (
    <div
      onClick={onClick}
      className={`${styles.tooltip}   ${
        cursor && 'cursor-pointer'
      } ${className}`}
    >
      {children}
      {text && (
        <span className={`${styles.tooltiptext} w-[120px]  ${extraClassName}`}>
          {text}
        </span>
      )}
    </div>
  );
};

export default TooltipBottom;
